// --- LAYOUT, COMPONENTS, PARTS --- //
$(function () {
    fn_layout_main();
    fn_comp_visual();
});

// --- MISC --- //
$(function () {
    nl_fn_footer();
    fn_wsw();
    nl_fn_anchor_link();
});

